import { render, staticRenderFns } from "./CoreBar.vue?vue&type=template&id=126cfb92&scoped=true"
import script from "./CoreBar.vue?vue&type=script&lang=js"
export * from "./CoreBar.vue?vue&type=script&lang=js"
import style0 from "./CoreBar.vue?vue&type=style&index=0&id=126cfb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126cfb92",
  null
  
)

export default component.exports